import { useSelector } from "react-redux";

const Loader = () => {
  const { loading } = useSelector((state) => state.ui);

  return (
    loading && (
      <div className="d-flex justify-content-center align-items-center vh-100 position-absolute top-0 w-100 loader">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  );
};

export default Loader;
